'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Bell, Search, Wifi } from 'lucide-react';
import AppLogo from '@/components/ui/AppLogo';
import { useLanguage } from '@/contexts/LanguageContext';


export default function Topbar() {
  const [searchOpen, setSearchOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'es' : 'en');
  };

  return (
    <header
      className="h-16 flex items-center justify-between px-4 lg:px-6 border-b flex-shrink-0 gap-4"
      style={{ background: 'hsl(222 40% 9%)', borderColor: 'hsl(222 25% 15%)' }}
    >
      {/* Left: Logo (mobile only) + Tournament Label */}
      <div className="flex items-center gap-3">
        <div className="lg:hidden flex items-center gap-2">
          <Link href="/landing" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <AppLogo size={28} />
            <span className="font-bold text-sm text-white">NOTICOPA</span>
          </Link>
        </div>
        <div className="hidden lg:flex items-center gap-2">
          <span className="text-base flex-shrink-0">🌐</span>
          <span className="text-xs font-semibold text-orange-400 tracking-widest uppercase">
            {t?.topbar?.tournament}
          </span>
        </div>
      </div>
      {/* Center: Live indicator */}
      <div className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full" style={{ background: 'hsl(189 94% 51% / 0.1)', border: '1px solid hsl(189 94% 51% / 0.2)' }}>
        <span className="w-2 h-2 rounded-full bg-cyan-400 live-pulse" />
        <span className="text-xs font-semibold text-cyan-400 tracking-wide">4 {t?.topbar?.matchesLive}</span>
        <Wifi size={12} className="text-cyan-400" />
      </div>
      {/* Right Actions */}
      <div className="flex items-center gap-1">
        <button
          onClick={() => setSearchOpen(!searchOpen)}
          className="btn-ghost p-2 rounded-lg"
          aria-label={t?.topbar?.search}
        >
          <Search size={18} />
        </button>
        <button className="btn-ghost p-2 rounded-lg relative" aria-label={t?.topbar?.notifications}>
          <Bell size={18} />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-orange-500" />
        </button>

        {/* Language Toggle */}
        <button
          onClick={toggleLanguage}
          className="flex items-center gap-1 px-2 py-1 rounded-lg transition-all duration-200 hover:scale-105 ml-1 group"
          style={{
            background: 'hsl(222 35% 14%)',
            border: '1px solid hsl(222 25% 20%)',
          }}
          aria-label={`Switch to ${language === 'en' ? 'Spanish' : 'English'}`}
          title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
        >
          <span className="text-xl leading-none drop-shadow-sm">{language === 'en' ? '🇺🇸' : '🇪🇸'}</span>
          <span
            className="text-[10px] font-semibold tracking-wider leading-none"
            style={{ color: 'hsl(222 15% 55%)' }}
          >
            {language === 'en' ? 'EN' : 'ES'}
          </span>
        </button>
      </div>
    </header>
  );
}